import React from "react";
import classes from "./PageHeader.module.less";

interface Props {
    title: string;
    subtitle?: string;
    extra?: React.ReactNode;
}

export const PageHeader: React.FC<Props> = ({ title, subtitle, extra }) => (
    <div className={classes.header}>
        <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 16 }}>
            <div>
                <h1 className={classes.title}>{title}</h1>
                {subtitle && <p className={classes.subtitle}>{subtitle}</p>}
            </div>
            {extra}
        </div>
    </div>
);
